/** @format */

import { Link } from 'react-router-dom';
import React from 'react';
import getRedirectionLink from 'src/utils/helper';
import { Button } from 'src/components/button';

const HeroWidget = props => {
  const { w, h, title, content, image: dataImage, link, linkTarget, linkTitle } = props.data;
  const image = process.env.REACT_APP_API_URL + dataImage;

  const handleButtonClick = () => {
    if (linkTarget === '_blank') {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <div className="hero-widget" data-width={w} data-height={h}>
      {image && <img className="hero-widget-image" src={image} alt={title} />}
      <div className="hero-widget-inner">
        <h2 className="hero-widget-title" title={title}>
          {title}
        </h2>
        <div className="hero-widget-content" title={content}>
          {content}
        </div>
        <div className="hero-widget-link">
          {link ? (
            <Button noArrow secondary white label={linkTitle} onClick={handleButtonClick} />
          ) : (
            <Link to={getRedirectionLink(props.data)}>
              <Button noArrow secondary white label={linkTitle} />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export { HeroWidget };
